import {
  GET_ALL_BANK_FAIL,
  GET_ALL_BANK_REQUEST,
  GET_ALL_BANK_SUCCESS,
  GET_SINGLE_BANK_FAIL,
  GET_SINGLE_BANK_REQUEST,
  GET_SINGLE_BANK_SUCCESS,
  ADD_BANK_FAIL,
  ADD_BANK_REQUEST,
  ADD_BANK_SUCCESS,
  UPDATE_BANK_FAIL,
  UPDATE_BANK_REQUEST,
  UPDATE_BANK_SUCCESS,
  DELETE_BANK_SUCCESS,
  DELETE_BANK_REQUEST,
  DELETE_BANK_FAIL,
  BANK_CLEAR_RECORD,
} from "../constant/BankConstant";
const initialState = {
  loading: false,
  action: "Bank",
  result: [],
  singledata: [],
  message: "",
  error: "",
  success: false,
};

const BankReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BANK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_BANK_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GET_ALL_BANK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GET_SINGLE_BANK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_BANK_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GET_SINGLE_BANK_FAIL:
      return {
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_BANK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_BANK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_BANK_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_BANK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_BANK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case UPDATE_BANK_FAIL:
      return {
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };
    case DELETE_BANK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_BANK_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_BANK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case BANK_CLEAR_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default BankReducer;
